import React, { useState, useEffect } from 'react'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import {
  bankSettingsAction,
  verifyBankAccountAction,
} from 'src/redux/actions/bankAction'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import { BankSpinner } from 'src/components/Global/Spinner/bankSpinner'
import { BankSettingsWrapper } from './style'
import { BankDetailsSpinner } from 'src/components/Global/Spinner/bankSpinner'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import Select from 'react-select'
import useSnackbar from 'src/hooks/useSnackBar'
import { useNavigate } from 'react-router'

const BankSetings = () => {
  const dispatch = useDispatch()
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  // useEffect(() => {
  //   dispatch(getAllBanksAction())
  // }, [dispatch])

  const allBanks = useTypedSelector((state) => state.banksResult?.banks)
  const { banks } = allBanks

  const getBankUserName = useTypedSelector(
    (state) => state.banksResult.bankSettingsSuccess
  )

  // console.log(getBankUserName.data.account_name)

  const options = banks?.map((bank: any) => {
    return {
      value: bank?.code,
      label: bank?.name,
      id: bank?.code,
    }
  })

  // bank verification Begins here
  const [bankSettings, setBankSettings] = useState({
    account_number: '',
    bank_code: '',
  })

  const [loading, setLoading] = useState(false)
  const [bankSettingsLoading, setBankSettingsLoading] = useState(false)

  let account_name: string = getBankUserName?.data?.account_name

  console.log(account_name)

  const { account_number, bank_code } = bankSettings

  const handleChange = (e: any) => {
    const { name, value } = e.target
    setBankSettings({ ...bankSettings, [name]: value })
  }

  const verifyState = {
    account_number,
    bank_code,
  }

  const verifyPayload = {
    verifyState,
  }

  const payload = {
    bankSettings: {
      ...bankSettings,
      account_name,
    },
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setBankSettingsLoading(true)
    dispatch(bankSettingsAction({ payload, onSuccess, onError }))
  }

  const onSuccess = (msg: string) => {
    setBankSettings({
      account_number: '',
      bank_code: '',
    })
    setBankSettingsLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    account_name = ''
    navigate(-1)
  }

  const onError = (msg: string) => {
    console.log(msg)
    setBankSettingsLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'error',
    })
  }

  const Disabled = () => {
    if (
      !account_number ||
      !bank_code ||
      account_number.length !== 10 ||
      bankSettingsLoading
    ) {
      return 'blur'
    }
    return null
  }

  useEffect(() => {
    if (account_number.length === 10 && bank_code) {
      dispatch(
        verifyBankAccountAction({
          verifyPayload,
          onVerifySuccess,
          onVerifyError,
        })
      )
      setLoading(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_number, bank_code, dispatch])

  const onVerifySuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }
  const onVerifyError = (msg: any) => {
    setLoading(false)
    console.log(msg)
    snackbar.trigger({
      message: msg,
      severity: 'error',
    })
  }

  const handleOption = (options: any) => {
    console.log(options.value)

    const bankCode = options.value

    setBankSettings({
      ...bankSettings,
      bank_code: bankCode,
    })
  }

  //react-select style
  const style = {
    control: (base: any) => ({
      ...base,
      boxShadow: 'none',
      border: '1px solid #6e7191',
      height: '55px',
      borderRadius: '10px',
      marginBottom: '30px',
    }),
  }

  return (
    <BankSettingsWrapper>
      <ModalTitleText>Bank Settings</ModalTitleText>
      <LabelText>
        This is where funds you have saved would be sent when you initiate a
        withdrawal. Funds are sent instantly.
      </LabelText>
      <form className="bank-form">
        <div className="bank-inputs-container">
          <LabelText>Account Number</LabelText>
          <QuicksaveInput
            type="number"
            name="account_number"
            value={account_number}
            placeholder="0123456789"
            onChange={handleChange}
            min="1"
            className="account_num_input"
          />
          {loading && <BankSpinner />}
        </div>

        <div className="bank-inputs-container">
          <LabelText>Bank Name</LabelText>
          <Select
            name={options?.label}
            value={options?.bank_code}
            placeholder="Select Bank"
            options={options}
            onChange={handleOption}
            className="bank_code_select"
            styles={style}
          />
        </div>

        <div className="bank-inputs-container name">
          <LabelText>Account Name</LabelText>
          <QuicksaveInput
            type="text"
            name="account_name"
            value={account_name}
            placeholder="Account name"
            readOnly
          />
        </div>

        <div className="top">
          <ModalButton className={`${Disabled()}`} onClick={handleSubmit}>
            Update {bankSettingsLoading && <BankDetailsSpinner />}
          </ModalButton>
        </div>
      </form>
    </BankSettingsWrapper>
  )
}

export { BankSetings }
